import React from 'react';
import Hero from './Hero';
import Services from './Services';
import ReviewSection from './ReviewSection';
import { Helmet } from "react-helmet";

function Home() {
  return (
    <>
      <Helmet>
        {/* Worldwide Title */}
        <title>ZYGMA Growth Solutions | Global Digital Marketing & SEO Agency</title>
        
        {/* Global Description */}
        <meta name="description" content="Dominate the global market with ZYGMA. We provide premium worldwide SEO, GMB Optimization, and Web Development services to scale your business internationally." />
        
        {/* Worldwide Keywords */}
        <meta name="keywords" content="Worldwide SEO Services, Global Digital Marketing Agency, International GMB Optimization, Professional Web Development, ZYGMA Growth Solutions, Scale Business Globally" />
        
        {/* Canonical Link (Self-referencing for SEO) */}
        <link rel="canonical" href="https://zygmagrowthsolutions.com/" />
      </Helmet>

      {/* Page Content */}
      <main>
        <Hero />
        <Services />
        <ReviewSection />
      </main>
    </>
  );
}

export default Home;